import { APP_VERSION } from './appVersion';
import { getOrCreateSessionId, getOrCreateTabOpenedAt } from './sessionMeta';
import { getCurrentRouteMeta } from './routeMeta';

export function buildMedhugRequestHeaders(extraHeaders = {}) {
  const { routePath, routeName } = getCurrentRouteMeta();

  const baseHeaders = {
    'X-Frontend-Version': APP_VERSION,
    'X-Session-Id': getOrCreateSessionId(),
    'X-Tab-Opened-At': getOrCreateTabOpenedAt(),
    'X-Route-Path': routePath,
    'X-Route-Name': routeName,
  };

  return {
    ...baseHeaders,
    ...extraHeaders,
  };
}
